import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useReport, useUpdateReport } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { formatDate } from "../../../helpers/date";

type IUpdateReport = {
  id: string;
};

export const UpdateReport: React.FC = () => {
  const { id } = useParams<IUpdateReport>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useReport(+id!);
  const { form, submit, loading } = useUpdateReport({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le rapport a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.report?.ok && data?.report?.result) {
      const { result } = data.report;
      form.setValue("customerId", result.customerId);
      form.setValue("weekStartDate", formatDate(result.weekStartDate));
      form.setValue("content", result.content);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  const report = data?.report?.result;

  return (
    <>
      <Header
        title="Rapport SEO"
        subtitle={report ? `#${report.id}` : ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/reports`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un rapport" />
          <div className="w-full">
            <div className="flex flex-wrap gap-3">
              <CustomerSelectSearch form={form} name="customerId" />
              <Input
                label="Semaine du"
                type="date"
                className="w-full"
                {...form.register("weekStartDate")}
              />
              <Textarea label="Contenu" className="w-full" {...form.register("content")} />
            </div>
            <div className="w-full mt-4">
              <Button onClick={submit} loading={loading} disabled={loading}>
                Valider
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
